import { useAppContext } from 'GlobalContext'
import { useEffect } from 'react'

function LinguaProvider(props) {


  const { children } = props
  //const setLingua = useLinguaSetter() // setter del contesto superiore
  //const lingua = useLinguaValue() 
  const { setLingua, lingua } = useAppContext()

   useEffect(() => {
    if (!lingua) setLingua(LINGUE[0].value)
  }, [lingua, setLingua])

  return children
}

const LINGUE = [
  { value: 'it', label: '🇮🇹 Italiano' },
  { value: 'de', label: '🇩🇪 Deutsch' },
  { value: 'en', label: '🇬🇧 English' },
  { value: 'fr', label: '🇫🇷 Français' },
]

// eslint-disable-next-line react-refresh/only-export-components
export { LinguaProvider, LINGUE }
